<template>
  <div>
    <el-row style="height: 30px; border-bottom: 1px solid #ddd">
      <el-col :span="24"> {{ info.referer_str }} - 退款单详情 </el-col>
    </el-row>
    <el-row style="height: 80px" type="flex" align="middle" justify="center">
      <el-col :span="24">
        <el-steps
          space="100%"
          :active="info.steps_label.index"
          finish-status="success"
          :process-status="info.steps_label.processStatus"
          align-center
        >
          <el-step
            v-for="(step, index) in info.steps_label.steps"
            :key="index"
            :title="step.title"
            :description="step.description"
          ></el-step>
        </el-steps>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-alert
          :title="`当前退款单状态：${info.statusname}`"
          :type="info.status == 3 ? 'success' : 'error'"
          :closable="false"
        >
        </el-alert>
      </el-col>
    </el-row>
    <el-row style="border: 1px solid #ddd">
      <el-col v-if="[0, 1, 4, 5].includes(Number(info.status))" :span="24">
        <el-row
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
          "
        >
          <el-col :span="24"> 基本信息 </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table :data="[info]" border style="width: 100%">
              <el-table-column prop="refund_id" label="退款单号" align="center">
              </el-table-column>
              <el-table-column prop="sum_num" label="退款货数量" align="center">
              </el-table-column>
              <el-table-column
                prop="market_name"
                label="市场/子市场"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="supply_name" label="商家" align="center">
              </el-table-column>
              <el-table-column prop="pg_name" label="代采组" align="center">
              </el-table-column>
              <el-table-column
                prop="refund_time"
                label="提交时间"
                align="center"
              >
              </el-table-column>
              <!--<el-table-column prop="transfer_time" label="收款日期" align="center" v-if="info.status!=0 ||  info.status!=1">-->
              <!--</el-table-column>-->
              <el-table-column
                prop="refund_statusname"
                label="退款方式"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="sum_price" label="退款金额" align="center">
              </el-table-column>
              <!--<el-table-column prop="serial_number" label="收款流水号" align="center">-->
              <!--</el-table-column>-->
            </el-table>
          </el-col>
        </el-row>
      </el-col>
      <el-col v-if="[2, 3, 11, 20].includes(Number(info.status))" :span="24">
        <el-row
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
          "
        >
          <el-col :span="24"> 退款信息 </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table :data="[info]" border style="width: 100%">
              <el-table-column prop="refund_id" label="退款单号" align="center">
              </el-table-column>
              <el-table-column prop="sum_num" label="退款货数量" align="center">
              </el-table-column>
              <el-table-column
                prop="market_name"
                label="市场/子市场"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="supply_name" label="商家" align="center">
              </el-table-column>
              <el-table-column prop="pg_name" label="代采组" align="center">
              </el-table-column>
              <el-table-column
                prop="refund_time"
                label="提交时间"
                align="center"
              >
              </el-table-column>
              <el-table-column
                v-if="info.status != 0 || info.status != 1"
                prop="transfer_time"
                label="收款日期"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="refund_statusname"
                label="退款方式"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="sum_price" label="退款金额" align="center">
              </el-table-column>
              <el-table-column
                prop="real_got_price"
                label="实收金额"
                align="center"
              >
                <template slot-scope="{ row }">
                  <div>{{ row.real_got_price }}</div>
                  <div v-if="info.status === constantMap.status.done">
                    （多收：{{
                      (row.real_got_price - row.sum_price).toFixed(2)
                    }}）
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="reason" label="财务备注" align="center">
              </el-table-column>
              <el-table-column prop="remark" label="代采备注" align="center">
              </el-table-column>
              <el-table-column
                prop="receive_account"
                label="收款账号"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="serial_number"
                label="收款流水号"
                align="center"
              >
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 单据信息等 -->
    <el-row v-if="[2, 3, 10, 11, 20].includes(Number(info.status))">
      <el-col :span="24" style="border: 1px solid #ddd">
        <div class="card-title">退款单据 {{ info.imgs.length }}张</div>
        <table style="width: 100%; border-collapse: collapse; color: #606266">
          <tr style="height: 120px">
            <td
              style="
                width: 50%;
                border: 1px solid #ddd;
                border-collapse: collapse;
                text-align: center;
              "
            >
              退款单据
            </td>
            <td
              style="
                width: 50%;
                border: 1px solid #ddd;
                border-collapse: collapse;
                padding: 0 40px;
              "
            >
              <div
                v-viewer
                style="
                  width: 40px;
                  height: 40px;
                  overflow: hidden;
                  cursor: pointer;
                  display: inline-block;
                "
              >
                <img
                  v-for="(img, index) in info.imgs"
                  :key="index"
                  :src="img"
                  style="width: 100%; height: 100%"
                />
              </div>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row
      v-if="info.status == 1 || info.status.toString() == '0'"
      :gutter="20"
    >
      <el-col :span="10">
        <div class="card-title">退款单据 {{ info.imgs.length }}张</div>
        <viewer class="viewer" :images="info.imgs">
          <img v-for="src in info.imgs" :key="src" :src="src" />
        </viewer>
      </el-col>
      <el-col :span="14">
        <el-row>
          <el-col>
            <div class="card-title">商品信息</div>
            <el-table :data="info.list" border style="width: 100%" height="400">
              <el-table-column
                prop="goods_name"
                label="商品名称"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="goods_no" label="货号" align="center">
              </el-table-column>
              <el-table-column prop="attr_label" label="属性" align="center">
              </el-table-column>
              <el-table-column prop="brand_name" label="品牌" align="center">
              </el-table-column>
              <el-table-column prop="pg_name" label="买手组" align="center">
              </el-table-column>
              <el-table-column
                prop="source_formal"
                label="退款来源"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="woid" label="代采单" align="center">
              </el-table-column>
              <el-table-column prop="work_id" label="售后工单ID" align="center">
              </el-table-column>
              <el-table-column prop="price" label="实付价" align="center">
              </el-table-column>
              <el-table-column prop="costs" label="小计" align="center">
              </el-table-column>
              <el-table-column prop="sum_price" label="退款金额" align="center">
              </el-table-column>
            </el-table>
            <div
              style="
                text-align: right;
                height: 40px;
                background: #f3f3f3;
                line-height: 40px;
                padding: 0 40px;
                font-size: 14px;
                color: #ff4040;
              "
            >
              合计退款金额： ¥{{ info.sum_price }}
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col
        v-if="[2, 3, 4, 5, 10, 11, 20].includes(Number(info.status))"
        :span="24"
      >
        <div class="card-title">商品信息</div>
        <el-table :data="info.list" border style="width: 100%" height="400">
          <el-table-column prop="img" label="商品图片" align="center">
            <template slot-scope="scope">
              <div
                v-viewer
                style="
                  width: 40px;
                  height: 40px;
                  overflow: hidden;
                  cursor: pointer;
                  margin: auto;
                "
              >
                <img style="width: 100%; height: 100%" :src="scope.row.img" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称" align="center">
          </el-table-column>
          <el-table-column prop="goods_no" label="货号" align="center">
          </el-table-column>
          <el-table-column prop="co_val" label="颜色" align="center">
          </el-table-column>
          <el-table-column prop="si_val" label="尺码" align="center">
          </el-table-column>
          <el-table-column prop="brand_name" label="品牌" align="center">
          </el-table-column>
          <el-table-column prop="pg_name" label="买手组" align="center">
          </el-table-column>
          <el-table-column prop="source_formal" label="退款来源" align="center">
          </el-table-column>
          <el-table-column prop="woid" label="代采订单" align="center">
            <template slot-scope="scope">
              <span style="margin-right: 10px">{{ scope.row.woid }}</span>
              <router-link
                style="color: #409eff; text-decoration: none"
                :to="`/home/purchaseorderdetail/${scope.row.woid}`"
              >
                查看
              </router-link>
            </template>
            woid
          </el-table-column>
          <el-table-column
            v-if="receipt_sn"
            prop="receipt_sn"
            label="代采退换货单"
            align="center"
          >
            <template slot-scope="scope">
              <span style="margin-right: 10px">{{ scope.row.receipt_sn }}</span>
              <router-link
                style="color: #409eff; text-decoration: none"
                :to="`/home/returnandexchangedetail/${scope.row.receipt_id}`"
              >
                查看
              </router-link>
            </template>
          </el-table-column>
          <el-table-column prop="work_id" label="售后工单ID" align="center">
          </el-table-column>
          <el-table-column prop="price" label="实付价" align="center">
          </el-table-column>
          <el-table-column prop="costs" label="小计" align="center">
          </el-table-column>
          <el-table-column prop="sum_price" label="退款金额" align="center">
          </el-table-column>
        </el-table>
        <div
          style="
            text-align: right;
            height: 40px;
            background: #f3f3f3;
            line-height: 40px;
            padding: 0 40px;
            font-size: 14px;
            color: #ff4040;
          "
        >
          合计退款金额： ¥{{ info.sum_price }}
        </div>
      </el-col>
    </el-row>
    <el-row>
      <div v-if="info.status == 1 || info.status == 0">
        <div class="card-title">退款信息</div>
        <el-row style="border: 1px solid #ddd; padding: 15px">
          <el-col style="height: 200px">
            <el-table :key="'eee'" :data="[info]" border style="width: 100%">
              <el-table-column prop="sum_price" label="收款日期" align="center">
                <template slot-scope="{}">
                  <el-date-picker
                    v-model="data.transfer_time"
                    placeholder="收款日期"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column prop="sum_price" label="退款方式" align="center">
                <template slot-scope="{}">
                  <el-select v-model="data.pay_tool" placeholder="退款方式">
                    <el-option
                      v-for="item in info.wcg_refund_refund_status"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="sum_price" label="退款金额" align="center">
              </el-table-column>
              <el-table-column prop="sum_price" label="实收金额" align="center">
                <template slot-scope="{}">
                  <el-input
                    v-model="data.real_got_price"
                    placeholder="实收金额"
                    label="scope.row.sum_price"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="overcharged_amount"
                label="多收金额"
                align="center"
              >
                <template
                  v-if="data.real_got_price && row.sum_price"
                  slot-scope="{ row }"
                  >{{
                    (data.real_got_price - row.sum_price).toFixed(2)
                  }}</template
                >
              </el-table-column>
              <el-table-column
                prop="receive_account"
                label="收款账号"
                align="center"
              >
                <template slot-scope="{}">
                  <el-select
                    v-model="data.receive_account"
                    placeholder="收款账号"
                    filterable
                    clearable
                    :remote-method="getReceiveAccount"
                  >
                    <el-option
                      v-for="item in receiveAccountOptions"
                      :key="item.rdid"
                      :value="item.rdname"
                      :label="item.rdname"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="sum_price"
                label="收款流水号"
                align="center"
              >
                <template slot-scope="{}">
                  <el-input
                    v-model="data.serial_number"
                    placeholder="收款流水号"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="代采备注" align="center">
              </el-table-column>
              <el-table-column prop="sum_price" label="财务备注" align="center">
                <template slot-scope="{}">
                  <el-input
                    v-model="textarea"
                    placeholder="财务备注"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="sum_price" label="操作" align="center">
                <template slot-scope="{}">
                  <div style="margin-bottom: 5px">
                    <el-button
                      class="btn-operation"
                      size="small"
                      type="success"
                      @click="pass"
                    >
                      审核通过
                    </el-button>
                  </div>
                  <div>
                    <el-button
                      class="btn-operation"
                      size="small"
                      type="danger"
                      @click="reject"
                    >
                      驳回
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-row>

    <!-- 申请作废 -->
    <el-row v-if="info.status == 3" style="display: none">
      <el-col :span="24">
        <div class="card-title">申请作废退款单</div>
        <el-table :data="[0]" :border="true">
          <el-table-column label="申请备注 (必填)" align="center">
            <template slot-scope="{}">
              <el-input
                v-model="cancel_apply_remark"
                placeholder="录入备注"
                style="width: 90%"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{}">
              <el-button type="danger" @click="toCancelApply">
                申请作废
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <!-- 驳回/同意作废申请 -->
    <el-row v-if="info.status == 20">
      <el-col :span="24">
        <div class="card-title">申请作废退款单</div>
        <el-table :data="[0]" :border="true">
          <el-table-column label="申请信息" align="center">
            <template slot-scope="{}">
              {{ info.cancel_reason }}
            </template>
          </el-table-column>

          <el-table-column label="填写备注" align="center">
            <template slot-scope="{}">
              <el-input
                v-model="reback_cancel_reason"
                placeholder="录入备注"
                style="width: 90%"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template slot-scope="{}">
              <el-button type="danger" @click="dealCancelApply(0)">
                驳回申请
              </el-button>
              <el-button type="primary" @click="dealCancelApply(1)">
                同意作废
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div class="card-title">操作信息</div>
        <el-table :data="logs" border style="width: 100%" height="400">
          <el-table-column prop="action_admin" label="操作人" align="center">
          </el-table-column>
          <el-table-column prop="action_type" label="操作方式" align="center">
          </el-table-column>
          <el-table-column prop="action_result" label="结果" align="center">
          </el-table-column>
          <el-table-column prop="create_time" label="操作时间" align="center">
          </el-table-column>
          <el-table-column prop="action_desc" label="备注" align="center">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getOperationReasonOption } from "@/openapi/modi/system_field.js";

const constantMap = Object.freeze({
  status: {
    done: "3",
  },
});
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      constantMap,
      info: {
        imgs: [],
        list: [],
        status: "",
        steps_label: {},
        statusname: "",
        sum_price: "",
      },
      data: {
        transfer_time: "",
        pay_tool: 0,
        serial_number: "",
        reason: "",
        real_got_price: 0,
        receive_account: "",
      },
      logs: null,
      textarea: "",
      url: "/erp/refund/checkRefundDetail",
      cancel_apply_remark: "", // 申请作废备注
      reback_cancel_reason: "", // 驳回作废申请备注
      receiveAccountOptions: [],
    };
  },
  mounted() {
    this.getReceiveAccount();
  },
  methods: {
    reject() {
      const args = {
        refund_id: this.$route.params.id,
        status: 2,
        reason: this.textarea,
      };
      const url = "/erp/refund/changeRefundStatus";
      this.$confirm("此操作将驳回订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.post(url, args).then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$notify({
                title: "操作成功",
                message: "已驳回该退款单",
                type: "success",
              });
              setTimeout(() => {
                this.fetchData();
              }, 300);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    pass() {
      if (this.data.real_got_price < 0) {
        this.$message.info("实收金额不能小于0");
        return;
      }
      if (!this.data.receive_account.trim()) {
        this.$message.info("收款账号必填");
        return;
      }
      if (
        !/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(
          this.data.real_got_price
        )
      ) {
        this.$message.info("实收金额格式错误");
        return;
      }
      const args = {
        refund_id: this.$route.params.id,
        status: 1,
        transfer_time: this.data.transfer_time,
        serial_number: this.data.serial_number,
        pay_tool: this.data.pay_tool,
        reason: this.textarea,
        real_got_price: this.data.real_got_price,
        receive_account: this.data.receive_account.trim(),
      };
      const url = "/erp/refund/changeRefundStatus";
      this.$confirm("是否通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http.post(url, args).then((res) => {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$notify({
                title: "操作成功",
                message: "已通过该退款单",
                type: "success",
              });
              setTimeout(() => {
                this.fetchData();
              }, 300);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    fetchData() {
      const args = {
        refund_id: this.$route.params.id,
      };
      this.$http.post(this.url, args).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.info = res.data.data.info;
          this.logs = res.data.data.logs;
          this.data.pay_tool = Number(this.info.refund_status);
          this.data.transfer_time = this.info.transfer_time;
          this.textarea = res.data.data.info.reason;
          this.data.real_got_price = res.data.data.info.real_got_price;
          this.data.receive_account = res.data.data.info.receive_account;
        }
      });
    },

    // 申请作废
    toCancelApply() {
      if (this.cancel_apply_remark.length === 0) {
        this.$message.error("请输入作废备注");
        return;
      }
      if (this.cancel_apply_remark.length > 250) {
        this.$message.error("");
        return;
      }
      this.$http
        .post("/erp/refund/cancelApply", {
          cacel_remark: this.cancel_apply_remark,
          refund_id: this.$route.params.id,
        })
        .then((rs) => {
          if (rs.data.code !== 200) {
            this.$message.error(rs.data.msg);
            return;
          }
          this.$message.success("已提交申请");
          this.fetchData();
        });
    },

    // 通过/驳回废弃申请
    // @param type 1同意 0驳回
    dealCancelApply(type) {
      // if(this.reback_cancel_reason.length == 0) return this.$message.error('请写入备注');
      const _msg = type
        ? '同意作废后, 退款单会被变成"已作废"状态, 欠货将原路返回'
        : '驳回申请后, 退款单状态恢复为"已完成"状态';
      this.$confirm(_msg, {
        confirmButtonText: type ? "同意作废" : "确定驳回",
      }).then(() => {
        this.$http
          .post("/erp/refund/dealCancelApply", {
            refund_id: this.$route.params.id,
            reback_cancel_reason: this.reback_cancel_reason,
            type,
          })
          .then((rs) => {
            if (rs.data.code !== 200) {
              this.$message.error(rs.data.msg);
              return;
            }
            this.$message.success("处理完成! ");
            this.fetchData();
          });
      });
    },
    // 获取收款账号
    getReceiveAccount() {
      // 参数是固定的
      const params = {
        key: "shoukuanzhanghao",
        query_scope: 1,
      };
      getOperationReasonOption(params)
        .then((res) => {
          this.receiveAccountOptions = res;
        })
        .catch((error) => {
          console.error("Error while fetching receive account options:", error);
        });
    },
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.card-title {
  background: #f3f3f3;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
}

.viewer {
  border: 1px solid #ddd;
  overflow: scroll;
  height: 438px;
}

.btn-operation {
  width: 100px;
}

.comment >>> textarea {
  color: #ff4040 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseRefundDetail.vue